import React from 'react';
export function PrivacyPolicy() {
  return <div className="prose prose-sm max-w-none" data-id="element-798">
      <p className="text-gray-600 mb-4" data-id="element-799">
        <strong data-id="element-800">Última actualización:</strong> Enero
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-801">
        1. Información que Recopilamos
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-802">
        Recopilamos información que nos proporcionas directamente cuando:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-803">
        <li data-id="element-804">Compras nuestro sistema de recetas</li>
        <li data-id="element-805">Te suscribes a nuestro newsletter</li>
        <li data-id="element-806">Nos contactas para soporte</li>
        <li data-id="element-807">Participas en nuestra comunidad</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-808">2. Uso de la Información</h3>
      <p className="text-gray-700 mb-4" data-id="element-809">Utilizamos tu información para:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-810">
        <li data-id="element-811">Procesar tus compras y enviarte el contenido digital</li>
        <li data-id="element-812">Enviarte actualizaciones del producto y recetas nuevas</li>
        <li data-id="element-813">Responder a tus consultas y brindarte soporte</li>
        <li data-id="element-814">Mejorar nuestros productos y servicios</li>
        <li data-id="element-815">Cumplir con obligaciones legales</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-816">3. Protección de Datos</h3>
      <p className="text-gray-700 mb-4" data-id="element-817">
        Implementamos medidas de seguridad para proteger tu información
        personal:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-818">
        <li data-id="element-819">Encriptación SSL en todas las transacciones</li>
        <li data-id="element-820">Servidores seguros y protegidos</li>
        <li data-id="element-821">Acceso limitado a información personal</li>
        <li data-id="element-822">Cumplimiento con GDPR y regulaciones internacionales</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-823">4. Cookies</h3>
      <p className="text-gray-700 mb-4" data-id="element-824">
        Utilizamos cookies para mejorar tu experiencia en nuestro sitio. Puedes
        configurar tu navegador para rechazar cookies, aunque esto puede afectar
        algunas funcionalidades del sitio.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-825">5. Compartir Información</h3>
      <p className="text-gray-700 mb-4" data-id="element-826">
        No vendemos ni compartimos tu información personal con terceros,
        excepto:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-827">
        <li data-id="element-828">Procesadores de pago necesarios para completar transacciones</li>
        <li data-id="element-829">
          Proveedores de servicios que nos ayudan a operar nuestro negocio
        </li>
        <li data-id="element-830">Cuando sea requerido por ley</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-831">6. Tus Derechos</h3>
      <p className="text-gray-700 mb-4" data-id="element-832">Tienes derecho a:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-833">
        <li data-id="element-834">Acceder a tu información personal</li>
        <li data-id="element-835">Corregir información incorrecta</li>
        <li data-id="element-836">Solicitar la eliminación de tus datos</li>
        <li data-id="element-837">Cancelar suscripciones en cualquier momento</li>
        <li data-id="element-838">Presentar una queja ante autoridades de protección de datos</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-839">7. Contacto</h3>
      <p className="text-gray-700 mb-4" data-id="element-840">
        Para cualquier consulta sobre esta política de privacidad, contáctanos
        a:
        <br data-id="element-841" />
        <strong data-id="element-842">Email:</strong>{' '}
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-843">
          contactomikioscodigital@gmail.com
        </a>
      </p>
    </div>;
}